import { Routes, Route } from 'react-router-dom'
import { SetupRoute, PublicOnlyRoute, ProtectedRoute, PermissionRoute } from './guards'
import { AppShell } from '../components/layout/AppShell'
import { SetupWizardPage } from '../modules/auth/SetupWizardPage'
import { LoginPage } from '../modules/auth/LoginPage'
import { DashboardPage } from '../modules/dashboard/DashboardPage'
import { ProjectsPage } from '../modules/projects/ProjectsPage'
import { ProjectDetailPage } from '../modules/projects/ProjectDetailPage'
import { TasksOverviewPage } from '../modules/tasks/TasksOverviewPage'
import { ChatPage } from '../modules/chat/ChatPage'
import { RemindersPage } from '../modules/reminders/RemindersPage'
import { UsersPage } from '../modules/users/UsersPage'
import { RolesPage } from '../modules/roles/RolesPage'
import { SettingsPage } from '../modules/settings/SettingsPage'
import { AuditPage } from '../modules/audit/AuditPage'
import { ServerPage } from '../modules/servers/ServerPage'
import { TimeTrackingPage } from '../modules/timeTracking/TimeTrackingPage'
import { ProfilePage } from '../modules/profile/ProfilePage'
import { NotFoundPage } from '../modules/NotFoundPage'

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<SetupRoute />}>
        <Route path="/setup" element={<SetupWizardPage />} />
      </Route>

      <Route element={<PublicOnlyRoute />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>

      <Route element={<ProtectedRoute />}>
        <Route element={<AppShell />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/profile" element={<ProfilePage />} />

          <Route element={<PermissionRoute anyOf={['projects.view']} />}>
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/projects/:id" element={<ProjectDetailPage />} />
          </Route>

          <Route element={<PermissionRoute anyOf={['tasks.view']} />}>
            <Route path="/tasks" element={<TasksOverviewPage />} />
          </Route>

          <Route element={<PermissionRoute anyOf={['chat.use']} />}>
            <Route path="/chat" element={<ChatPage />} />
          </Route>

          <Route path="/reminders" element={<RemindersPage />} />

          <Route element={<PermissionRoute anyOf={['users.view']} />}>
            <Route path="/users" element={<UsersPage />} />
            <Route path="/roles" element={<RolesPage />} />
          </Route>

          <Route element={<PermissionRoute anyOf={['logs.view']} />}>
            <Route path="/audit" element={<AuditPage />} />
          </Route>

          <Route element={<PermissionRoute anyOf={['servers.view']} />}>
            <Route path="/servers" element={<ServerPage />} />
          </Route>

          <Route element={<PermissionRoute anyOf={['projects.view']} />}>
            <Route path="/time-tracking" element={<TimeTrackingPage />} />
          </Route>

          <Route element={<PermissionRoute anyOf={['settings.manage']} />}>
            <Route path="/settings" element={<SettingsPage />} />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  )
}
